import { Editor } from '@tiptap/core'
import StarterKit from '@tiptap/starter-kit'
export const containsHTML = (html: string) => /<\/?[a-z][\s\S]*>/i.test(html)

export const parseHTMLToPlainText = (value: string): string => {
  if (!value) return ''
  if (!containsHTML(value)) return value

  try {
    const editor = new Editor({
      content: value,
      extensions: [StarterKit.configure()],
    })

    return editor.getText({ blockSeparator: '\n' })
  } catch (e) {
    return ''
  }
}
